import React, {ReactComponentElement, useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native-web';
import ENV from '../../../environment';
import IframeZoom from './components/Zoom/IframeZoom';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import Divider from '@/Atoms/Divider/Divider';
import {ScrollView} from 'react-native';
import {useNavigation, useRoute} from '@react-navigation/native';
import webinarStore from './store/zoomInfoStore';
import Loader from '@/Atoms/CCLoader/CCLoader';
import {ScreenName} from '@/navigators/StackConstants';
import ActivePuzzle from './components/ActivePuzzle/ActivePuzzle';
import useClassroomInfoApi from '@/Hooks/ClassroomInfoApi/useClassroomInfoApi';
import useVerifyPuzzleApi from '@/Hooks/ClassroomInfoApi/useVerifyPuzzleApi';
import ComingSoon from '../ComingSoon';

const Classroom = ({dashboardData}) => {
  const route = useRoute();
  const params = route.params as any;
  const webinarKey = params?.webinarKey;

  const webinarData = webinarStore?.[webinarKey];
  console.log('Webinarkey is ', webinarKey, 'Webinar Data', webinarData);

  if (!webinarData) {
    console.error('webinarData not found in store. Redirecting...');
    const navigation = useNavigation();
    navigation.navigate(ScreenName.Books, {tab: 'meeting'});
  }
  const {token, meetingId, password, occurenceId, meetingRole, isZoomMeeting} =
    webinarData ?? {};
  //const {token, meetingId, password, occurenceId} = webinarData ?? {};
  // console.log('token and all', token, meetingId, password);

  const [activeTabLeft, setActiveTabLeft] = useState<number>(0);
  const [activeTabRight, setActiveTabRight] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const {first_name, last_name, username, mobile_number} =
    dashboardData?.user || {};
  const userName =
    first_name?.trim() || last_name?.trim()
      ? `${first_name ?? ''} ${last_name ?? ''}`.trim()
      : username?.trim() || mobile_number?.trim() || 'Guest';

  const userEmail =
    isZoomMeeting === 1
      ? dashboardData?.user?.email
      : meetingRole === 'host'
      ? 'support@circlechess.com'
      : dashboardData?.user?.email;
  const userId: string = dashboardData?.user?.user_id;

  // const {token, meetingId, password, occurenceId} = webinarStore[webinarKey];
  // console.log('webinarUrl from param', webinar_url);
  console.log('Class room dashboard', userName, userEmail);

  const tabsLeft = [
    {
      key: 'Coach Screen',
      label: 'Coach Screen',
      icon: 'monitor',
      component: IframeZoom,
      getProps: () => ({
        zoomMeetingInfo,
      }),
      // component: () => (
      //   <Text>Coming soon.</Text>
      //   // <Text>This is the content for Past Puzzles & Polls.</Text>
      // ),
    },
    // {
    //   key: 'Past Puzzles & Polls',
    //   label: 'Past Puzzles & Polls',
    //   icon: 'check-circle-outline',
    //   component: () => (
    //     <Text>Coming soon.</Text>
    //     // <Text>This is the content for Past Puzzles & Polls.</Text>
    //   ),
    // },
    // {
    //   key: 'Active Puzzle',
    //   label: 'Active Puzzle',
    //   icon: 'puzzle-outline',
    //   // component: ActivePuzzle,
    //   // getProps: () => ({
    //   //   meetingId,
    //   //   occurenceId,
    //   //   meetingRole,
    //   //   currentActivePuzzle,
    //   //   verifyPuzzle,
    //   //   verifyPuzzleData,
    //   // }),
    //   component: () => (
    //     <Text>Coming soon.</Text>
    //     //<Text>This is the content for Active Puzzle.</Text>
    //   ),
    // },
  ];

  const tabsRight = [
    // {
    //   key: 'Chat Room',
    //   label: 'Chat Room',
    //   icon: 'chat',
    //   component: () => <Text>Coming soon.</Text>,
    //   getProps: () => ({
    //     // dashboardData,
    //   }),
    // },
    // {
    //   key: 'Leaderboard',
    //   label: 'Leaderboard',
    //   icon: 'chart-box-outline',
    //   component: () => <Text>Coming soon.</Text>,
    // },
    {
      key: 'Summary',
      label: 'Summary',
      icon: 'note-text-outline',
      component: () => <ComingSoon />,
    },
  ];

  const [zoomMeetingInfo, setZoomMeetingInfo] = useState<{
    meetingId: string;
    tk: string;
    pwd: string;
    signature: string;
    userName: string;
    userEmail: string;
  }>({
    meetingId: `${meetingId}`,
    tk: `${token}`,
    pwd: `${password}`,
    signature: '',
    userName: `${userName}`,
    userEmail: `${userEmail}`,
  });
  const [role, setRole] = useState<number>(0);
  const [currentActivePuzzle, setcurrentActivePuzzle] = useState({
    puzzleId: '',
    puzzleName: '',
    totalMoveCount: '',
    startingFEN: '',
    orientation: '',
    puzzleTime: '',
  });

  const {mutate: verifyPuzzle, data: verifyPuzzleData} = useVerifyPuzzleApi();

  const handleOnSuccessClassroomInfo = data => {
    console.log('Signaure received?', data);
    setZoomMeetingInfo(prev => ({...prev, signature: data?.signature}));
    // setRole(data.role);
    setcurrentActivePuzzle({
      puzzleId: data?.active_puzzle?.puzzle_id,
      puzzleName: data?.active_puzzle?.puzzle_name,
      totalMoveCount: data?.active_puzzle?.total_move_count,
      startingFEN: data?.active_puzzle?.starting_fen,
      orientation: data?.active_puzzle?.orientation,
      puzzleTime: data?.active_puzzle?.puzzle_time,
    });
  };

  //can be removed
  useEffect(() => {
    console.log('Zoom info from server in useEffect', zoomMeetingInfo);
    if (
      zoomMeetingInfo.signature &&
      zoomMeetingInfo.meetingId &&
      zoomMeetingInfo.tk &&
      zoomMeetingInfo.pwd
    ) {
      setLoading(false);
    }
  }, [zoomMeetingInfo]);

  useEffect(() => {
    console.log(
      'Current Active Puzzle from Server in useEffect',
      currentActivePuzzle,
    );
  }, [currentActivePuzzle]);

  const {mutate: getClassroomInfo} = useClassroomInfoApi(
    handleOnSuccessClassroomInfo,
  );

  useEffect(() => {
    if (
      !zoomMeetingInfo.signature &&
      zoomMeetingInfo.meetingId &&
      zoomMeetingInfo.tk &&
      zoomMeetingInfo.pwd
    ) {
      getClassroomInfo({
        meetingId: zoomMeetingInfo.meetingId,
        userId,
        occurenceId,
        meetingRole,
      });
    }
  }, [
    zoomMeetingInfo.meetingId,
    zoomMeetingInfo.tk,
    zoomMeetingInfo.pwd,
    userId,
  ]);

  useEffect(() => {
    return () => {
      delete webinarStore[webinarKey];
    };
  }, [webinarKey]);

  return (
    <>
      <Loader loading={loading} textToShow={'Loading Your Classroom'} />
      <Divider width={1} />
      <View style={styles.container}>
        <Divider width={1} isVertical={true} />
        {/* Container 1 - Left 70% */}
        <View style={styles.leftTabsContainer}>
          <View style={styles.tab}>
            {tabsLeft.map((tab, tabIndex) => (
              <TouchableOpacity
                key={tab.label}
                onPress={() => setActiveTabLeft(tabIndex)}>
                <View
                  style={[
                    styles.tab,
                    activeTabLeft === tabIndex && styles.activeTab,
                  ]}>
                  <Icon
                    name={tab.icon}
                    size={20}
                    color={
                      activeTabLeft === tabIndex
                        ? CCColors.TextColor.Primary
                        : CCColors.TextColor.LightGrey
                    }
                  />
                  <CCText
                    style={[
                      styles.leftTabTitle,
                      activeTabLeft === tabIndex && styles.activeTab,
                    ]}
                    fontSize={14}>
                    {tab.label}
                  </CCText>
                </View>
                <View
                  style={[
                    activeTabLeft === tabIndex
                      ? styles.tabUnderline
                      : {marginTop: 10},
                  ]}
                />
              </TouchableOpacity>
            ))}
          </View>
          <Divider width={1} />
          {/* Tab Content */}
          <View style={styles.leftTabContentContainer}>
            {tabsLeft.map((tab, tabIndex) => {
              const {component: LeftComponent, getProps} = tab;
              return (
                <View
                  key={tabIndex}
                  style={[
                    styles.leftTabContent,
                    activeTabLeft === tabIndex && styles.leftTabActiveContent,
                    activeTabLeft !== tabIndex && {display: 'none'},
                  ]}>
                  {zoomMeetingInfo.signature !== '' ? (
                    <LeftComponent {...(getProps ? getProps() : {})} />
                  ) : (
                    <CCText>Loading Your Class</CCText>
                  )}
                </View>
              );
            })}
          </View>
        </View>
        <Divider width={1} isVertical={true} />
        {/* Container 2 - Right 30% */}
        <View style={styles.rightTabsContainer}>
          <View style={styles.tab}>
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              {tabsRight.map((tab, tabIndex) => (
                <TouchableOpacity
                  key={tab.label}
                  onPress={() => setActiveTabRight(tabIndex)}>
                  <View
                    style={[
                      styles.tab,
                      activeTabRight === tabIndex && styles.activeTab,
                    ]}>
                    <Icon
                      name={tab.icon}
                      size={20}
                      color={
                        activeTabRight === tabIndex
                          ? CCColors.TextColor.Primary
                          : CCColors.TextColor.LightGrey
                      }
                    />
                    <CCText
                      style={[
                        styles.rightTabTitle,
                        activeTabRight === tabIndex && styles.activeTab,
                      ]}
                      fontSize={14}>
                      {tab.label}
                    </CCText>
                  </View>
                  <View
                    style={[
                      activeTabRight === tabIndex
                        ? styles.tabUnderline
                        : {marginTop: 10},
                    ]}
                  />
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
          <Divider width={1} />
          {/* Tab Content */}
          <View style={styles.rightTabContentContainer}>
            {tabsRight.map((tab, tabIndex) => {
              const {component: RightComponent, getProps} = tab;
              return (
                <View
                  key={tabIndex}
                  style={[
                    styles.rightTabContent,
                    activeTabRight !== tabIndex && {display: 'none'},
                  ]}>
                  {activeTabRight === tabIndex && (
                    <RightComponent {...(getProps ? getProps() : {})} />
                  )}
                </View>
              );
            })}
          </View>
        </View>
      </View>
    </>
  );
};

export default Classroom;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    // flex: 1,
    // flexWrap: 'wrap',
    backgroundColor: CCColors.Primary.lightBrown,
  },
  leftTabsContainer: {
    // flexDirection: 'column',
    flex: 7,
    justifyContent: 'flex-start',
  },
  rightTabsContainer: {
    flex: 3,
    justifyContent: 'flex-start',
  },
  tab: {
    paddingHorizontal: 10,
    padding: 10,
    paddingTop: 7,
    paddingBottom: 0,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    backgroundColor: CCColors.White,
  },
  activeTab: {
    fontWeight: 'bold',
  },
  tabUnderline: {
    marginTop: 7,
    height: 2,
    backgroundColor: CCColors.Primary.Default,
  },
  leftTabTitle: {
    marginLeft: 8,
    marginRight: 20,
    // marginBottom: 10,
    color: CCColors.TextColor.Primary,
  },
  rightTabTitle: {
    marginLeft: 8,
    marginRight: 8,
    // marginBottom: 10,
    color: CCColors.TextColor.Primary,
  },
  leftTabContentContainer: {
    position: 'relative',
    height: '70%',
    backgroundColor: CCColors.Primary.lightBrown,
    //backgroundColor: 'blue',
  },
  leftTabContent: {
    paddingHorizontal: 15,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    opacity: 0,
    pointerEvent: 'none',
  },
  leftTabActiveContent: {zIndex: 2, opacity: 1, pointerEvents: 'auto'},
  rightTabContentContainer: {
    height: '70%',
    backgroundColor: CCColors.Primary.lightBrown,
  },
  rightTabContent: {
    flex: 1,
    paddingHorizontal: 8,
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    paddingTop: 20,
  },
});
